// October 2026 monthly report companion blog.
import { defineDocument, em, link, p, section, text } from '../../schema';
const description = 'nanos world learns German, Sonic speeds into third, and Nintendo Switch Sports Resort serves up a big launch in our October 2026 Twitch party game report.';
export const blogPartyGameStreamingByTheNumbersOctober2026Document = defineDocument({
    id: 'blog:party-game-streaming-by-the-numbers-october-2026',
    kind: 'blog',
    slug: 'party-game-streaming-by-the-numbers-october-2026',
    route: '/blog/party-game-streaming-by-the-numbers-october-2026',
    seo: {
        title: 'Party Game Streaming by the Numbers: October 2026',
        description,
        imageAsset: 'twitchStats202610',
    },
    hero: {
        eyebrow: [text('Airhead Blog')],
        title: [text('Party Game Streaming by the Numbers: October 2026')],
        description: [text(description)],
        imageAsset: 'twitchStats202610',
        imageAlt: 'Nintendo Switch Sports Resort cover art, MontanaBlack88 in a GET ON MY LVL shirt, and Sonic Racing: CrossWorlds cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-11-02T00:00:00.000Z'),
        updatedAt: new Date('2026-11-02T00:00:00.000Z'),
        tags: ['party-central'],
    },
    sections: [
        section({
            id: 'article',
            blocks: [
                p([
                    text('On October 10, Zenkai, a Naruto roleplay community in '),
                    em('nanos world'),
                    text(', opened a German server, and German streamers lined up to become ninjas. By the end of the month, 309 of them had played the game, nearly all for the first time.'),
                ]),
                p('Across all the party games we track on Twitch, October ran close to September’s pace, with about 173,000 captured streams from 69,000 streamers. The action was inside a few games: a new ninja village, Sonic’s festival weekends, a Nintendo launch, a Halloween scare, and four streamers who shared first place in four different languages.'),
            ],
            sections: [
                section({
                    id: 'article__guten-tag-shinobi',
                    title: 'Guten Tag, Shinobi',
                    blocks: [
                        p([
                            link('https://store.steampowered.com/app/1841660/nanos_world/', 'nanos world'),
                            text(' is a multiplayer sandbox where communities run their own servers, from shooters to roleplay. French streamers have played out Naruto stories on Zenkai since at least April, and the game has led our rankings every month since August.'),
                        ]),
                        p([
                            text('German streamers announced the new Zenkai server in their stream titles, and '),
                            link('/party-central?y=language&from=2026-09-01T00%3A00%3A00.000Z&to=2026-11-01T00%3A00%3A00.000Z&game=1763263', 'German streams of the game'),
                            text(' rose from 156 in September to 3,964. French play grew too, from 3,177 streams to 4,194. Altogether, the game more than doubled, to 8,347 streams from 623 streamers.'),
                        ]),
                        p([
                            text('The newcomers didn’t just visit. Most kept coming back, and German streamers now draw slightly more of the game’s viewership than French streamers, 51% to 48%. '),
                            link('https://twitch.tv/onlyjson', 'onlyjson'),
                            text(', '),
                            link('https://twitch.tv/xrick75', 'xrick75'),
                            text(', '),
                            link('https://twitch.tv/jerzy', 'jerzy'),
                            text(', and '),
                            link('https://twitch.tv/tosho0', 'Tosho0'),
                            text(' drew the largest German audiences, nearly half of the game’s German viewership between them. The new server reshaped German streaming as a whole: '),
                            em('nanos world'),
                            text(' made up 30% of all German party game streams in October.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__gotta-go-fest',
                    title: 'Gotta Go Fest',
                    blocks: [
                        p([
                            em('Sonic Racing: CrossWorlds'),
                            text(', Sega’s kart racer, returned to our top 15 for the first time since February and finished third. It got '),
                            link('https://nintendowire.com/news/2026/10/02/sonic-racing-crossworlds-october-content-features-hatsune-miku-event-avatar-legends-dlc-and-more/', 'three event weekends'),
                            text(': a Hatsune Miku festival, the World Championship Finals with Twitch Drops and a viewer badge, and an Avatar Legends festival. Those weekends held more than half of the game’s October streams. Some streamers came for the badge, but others stayed: by the end of October, nearly twice as many streams of the game were live at a time as in late September.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__game-set-launch',
                    title: 'Game, Set, Launch',
                    blocks: [
                        p([
                            link('https://www.nintendo.com/en-gb/Games/Nintendo-Switch-2-games/Nintendo-Switch-Sports-Resort-3115652.html', 'Nintendo Switch Sports Resort'),
                            text(' arrived on Switch 2 on October 22. Its name nods to '),
                            em('Wii Sports Resort'),
                            text(', the 2009 Wii classic, and Nintendo built it around motion controls, with bowling, golf, tennis, archery, volleyball, jet ski, flight, and even thumb wrestling.'),
                        ]),
                        p([
                            text('It was October’s biggest new release, with 1,941 streams from 1,056 streamers in its first 10 days. Launch day was its busiest, with 403 streams averaging 133 viewers. The audience was spread across many channels, and the biggest launch-night stream came from the Brazilian streamer '),
                            link('https://twitch.tv/alanzoka', 'alanzoka'),
                            text('.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__first-place-four-ways',
                    title: 'First Place, Four Ways',
                    blocks: [
                        p('Four streamers tied for first in our streamer rankings, each in a different language.'),
                        p([
                            link('https://twitch.tv/getonmylvltv', 'GetOnMyLvLTV'),
                            text(' is '),
                            link('https://twitch.tv/montanablack88', 'MontanaBlack88'),
                            text('’s rerun channel, playing old streams from one of Germany’s biggest Twitch streamers around the clock. In October it reran '),
                            em('Fall Guys'),
                            text(', '),
                            em('Mario Kart 8 Deluxe'),
                            text(', '),
                            em('Pummel Party'),
                            text(', and '),
                            em('Among Us'),
                            text(' sessions from 2020 to 2022. One '),
                            em('Pummel Party'),
                            text(' rerun on October 18 drew 3,538 viewers. Good party game chaos holds up.'),
                        ]),
                        p([
                            link('https://twitch.tv/mang0', 'mang0'),
                            text(', best known for '),
                            em('Super Smash Bros. Melee'),
                            text(', spent most of their time in '),
                            em('Mario Kart Wii'),
                            text(' and climbed from 15th in August, to third in September, to a share of first in October. '),
                            link('https://twitch.tv/jotta', 'jotta'),
                            text(' debuted in our top 15, playing '),
                            em('Words On Stream'),
                            text(' in Portuguese through Jottathon 2, a marathon that began in September and ran through October. '),
                            link('https://twitch.tv/nohoho12', 'のほほ'),
                            text(' has made our top 15 every month since February.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__trick-or-stream',
                    title: 'Trick or Stream',
                    blocks: [
                        p([
                            text('Halloween fell on a Saturday, and horror games got the treat. '),
                            em('Lethal Company'),
                            text(', the cooperative survival horror game, held steady through October, then '),
                            link('/party-central?from=2026-09-01T00%3A00%3A00.000Z&to=2026-11-01T00%3A00%3A00.000Z&game=2085980140', 'jumped on October 31'),
                            text(', with 76% more streams live at a time than on the month’s other Saturdays. More than a third of its Halloween streams named the holiday in their titles. The cooperative horror game '),
                            em('KLETKA'),
                            text(' also doubled its usual Saturday streams, on a smaller scale.'),
                        ]),
                        p([
                            text('Across the month, '),
                            em('Lethal Company'),
                            text(' reached 4,809 streamers, its most since May.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__read-the-full-report',
                    title: 'Read the Full Report',
                    blocks: [
                        p([
                            text('There’s more in the '),
                            link('/party-central/reports/2026-10-top-party-games-and-streamers', 'full October 2026 report'),
                            text(', including how one Japanese streamer kept '),
                            em('Mario Kart World'),
                            text(' in second place and how '),
                            em('Jackbox Party Packs'),
                            text(' reached its best rank yet. It also has complete language and game breakdowns, plus streaming patterns by day and hour.'),
                        ]),
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=party-game-streaming-by-the-numbers-october-2026.js.map